import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './EditGeofenceHeader.module.scss';
import DeleteAction from '@casops/components/tables/cells/model-actions/components/delete-action/DeleteAction';
import { GeofenceModel, useDeleteGeofenceMutation } from '@casops/store/apis/geofencesApi';
import { ModelName } from '@casops/store/api';
import { getDefaultModelArg } from '@casops/components/tables/cells/model-actions/utils';
import Skeleton from 'react-loading-skeleton';
import { HOME_OVERVIEW_GEOFENCES } from '@casops/navigation';

type Model = GeofenceModel;
const modelName = ModelName.Geofence;

const getItemName = (data: Model): string => data.name;

interface EditGeofenceHeaderProps {
  item?: Model;
}

export const EditGeofenceHeader = ({ item }: EditGeofenceHeaderProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <div className={styles.header__title}>{t('GeofenceProperties')}</div>
      {item ? (
        <DeleteAction<Model>
          modelName={modelName}
          data={item}
          getItemName={getItemName}
          getQueryArg={getDefaultModelArg}
          useDeleteModelMutation={useDeleteGeofenceMutation}
          canDeleteItem={true}
          isIconButton={true}
          navigateTo={HOME_OVERVIEW_GEOFENCES}
        />
      ) : (
        <Skeleton width={20} height={20} />
      )}
    </div>
  );
};

export default EditGeofenceHeader;
